import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class KSTSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForKST = this.yAccessorForKST.bind(this);
    this.yAccessorForSignal = this.yAccessorForSignal.bind(this);
  }

  static yExtents(datum, index, allData, indicator) {
    const dataArr = Array.isArray(allData)
      ? allData
      : Array.isArray(datum)
        ? datum
        : [datum];

    if (!indicator || !indicator.renderKey) {
      return [-10, 10];
    }

    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;

    dataArr.forEach((item) => {
      const node = item && item[indicator.renderKey];
      if (!node || typeof node !== "object") return;

      const updateExtents = (value) => {
        if (!Number.isFinite(value)) return;
        if (value < min) min = value;
        if (value > max) max = value;
      };

      updateExtents(node.kst);
      updateExtents(node.signal);
    });

    // Default to -10 to 10 if no valid data
    if (
      !Number.isFinite(min) ||
      !Number.isFinite(max) ||
      min === Number.POSITIVE_INFINITY
    ) {
      return [-10, 10];
    }

    // Ensure zero line is always visible
    min = Math.min(min, 0);
    max = Math.max(max, 0);

    // Add padding (10% of range)
    const range = max - min;
    const padding = range * 0.1;

    return [min - padding, max + padding];
  }

  yAccessorForKST(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).kst;
  }

  yAccessorForSignal(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).signal;
  }

  render() {
    const { className, onDoubleClick, onContextMenu } = this.props;
    const { strokeKST, strokeSignal, strokeZeroLine } = this.props;
    const { clip } = this.props;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorForKST}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeKST}
          clip={clip}
        />
        <LineSeries
          yAccessor={this.yAccessorForSignal}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeSignal}
          clip={clip}
        />
        <StraightLine
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeZeroLine}
          yValue={0}
        />
      </g>
    );
  }
}

KSTSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  clip: PropTypes.bool.isRequired,
  strokeKST: PropTypes.object.isRequired,
  strokeSignal: PropTypes.object.isRequired,
  strokeZeroLine: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

KSTSeries.defaultProps = {
  className: "react-stockcharts-kst-series",
  clip: true,
};

export default KSTSeries;
